import {mapMutations, mapState} from 'vuex';
import {MEDIA, ACTION} from '~/consts';
import crypto from 'crypto-js';

let store
if (process.browser) {
  window.onNuxtReady(({$store}) => {
    store = $store
  })
}

const helpers = {
  ...mapMutations({
    toggleEditMode: 'toggleEditMode',
  }),
  getDateOfTokenExpires() {
    return moment().local()
      .add(1, "week")
      .set({ hour: 3, minute: 0, second: 0, millisecond: 0 })
      .toDate()
  },
  get_cookie_domain(host = null) {
    host = !this.isEmpty(host) ? host : window.location.hostname;
    let cookie_domain = '.' + this.getDomain(host, false)

    if ((!process.server) && host.includes('localhost') && process.env.APP_ENV === 'development') {
      host = window.location.host.split(':')[0];
      let splitted_host = host.split('.')
      host = !this.isEmpty(splitted_host[1]) ? `.${host}` : host
    }

    return cookie_domain;
  },
  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, '');

    if (!subdomain) {
      url = url.split('.');

      url = url.slice(url.length - 2).join('.');
    }

    if (url.indexOf('/') !== -1) {
      return url.split('/')[0];
    }

    return url;
  },
  getLocationOrigin(url) {
    let arr = url.split('/');
    return arr[0] + "//" + arr[2];
  },
  get_api_url() {
    return process.env.API_URL;
  },
  get_web_url() {
    return window.location.origin;
  },
  loginWith(provider) {
    window.location.href = `${process.env.API_URL}/auth/${provider}`;
  },
  str_limit(str, limit = 10) {
    if (!this.isEmpty(str) && str.length > limit) {
      str = str.substring(0, limit) + '...';
    }

    return str;
  },
  capitalize(text) {
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  },
  async download(media, group_id = null) {
    if (this.loading_download_media) {
      return;
    }

    this.loading_download_media = true;
    if (media.storageType == 'google_drive') {
      if (this.isEmpty(media.values)) {
        this.loading_download_media = false;
        return
      }
      if (!this.isEmpty(media.values.downloadLink)) {
        window.open(media.values.downloadLink, "_blank");
      } else {
        window.open(media.values.webViewLink, "_blank");
      }

      this.loading_download_media = false;

      return;
    }

    const account = !this.isEmpty(this.auth) && !this.isEmpty(this.auth.activeAccount) ? this.auth.activeAccount : null;
    const userId = media.userId ?? media.user_id;
    const isMyOwnMedia = userId === this.auth.id || (!this.isEmpty(account) && account.id === media.universityUserId);

    let downloadUrl = null;

    if (isMyOwnMedia) {
      const { data } = await this.$axios.post(MEDIA.DOWNLOAD_MY_OWN(media.id));
      if (data.applicationSystem.code !== 0) {
        toast.danger(data.applicationSystem.message);
        this.loading_download_media = false;
        return;
      }

      downloadUrl = data.data.downloadUrl;
    } else if (group_id != null) {
      const { data } = await this.$axios.post(MEDIA.DOWNLOAD_SHARED_IN_CLASS(media.id), undefined, {
        headers: {
          "x-gid": group_id,
        }
      });

      if (data.applicationSystem.code !== 0) {
        toast.danger(data.applicationSystem.message);
        this.loading_download_media = false;
        return;
      }

      downloadUrl = data.data.downloadUrl;
    } else {
      toast.danger('Gagal mengunduh data');
      return;
    }

    window.open(downloadUrl, "_blank");
    this.loading_download_media = false;
  },
  track(category, action, reference_id = null, u_type = 'u', u_id = null, value = null) {
    let data = {
      category, action, reference_id, u_type, u_id, value
    };

    if (u_type == 'gm' && !this.isEmpty(u_id)) {
      data['u_id'] = u_id
    }

    this.$axios.post(ACTION.TRACK, data)
      .then()
      .catch()
  },
  export(url, postData, callback) {
    postData = typeof postData === 'string' ? {format: postData} : postData;

    callback = !this.isEmpty(callback) ? () => {
    } : callback;

    let attr = {
      mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      name: moment().format('x') + '.xlsx'
    }

    switch (postData.format) {
      case 'pdf':
        attr = {
          mime: 'application/pdf',
          name: moment().format('x') + '.pdf'
        }
        break;

      case 'csv':
        attr = {
          mime: 'text/csv',
          name: moment().format('x') + '.csv'
        }
        break;
    }

    store.commit('setState', {key: 'is_export_report_loading', value: true});

    this.$axios.request({
      url: url,
      method: 'POST',
      responseType: 'blob',
      data: postData,
      timeout: 60000,
    })
      .then(({data}) => {
        const blob_data = new Blob([data], {type: attr.mime});
        const downloadUrl = window.URL.createObjectURL(blob_data);

        const link = document.createElement('a');

        link.href = downloadUrl;

        link.setAttribute('download', attr.name); //any other extension

        document.body.appendChild(link);

        link.click();

        link.remove();

        setTimeout(() => {
          store.commit('setState', {key: 'is_export_report_loading', value: false});
        }, 1000);
      }).catch(() => {
      toast.danger('Gagal mengunduh data');
      setTimeout(() => {
        store.commit('setState', {key: 'is_export_report_loading', value: false});
      }, 1000);
    });
  },
  strip_tags(html) {
    return html.replace(/(<([^>]+)>)/ig, "");
  },
  getPeriodLabel(period) {
    let value = '-';
    if (!this.isEmpty(period)) {
      period = collect(this.$store.state.universities.periods).where('value', '==', period).first();

      if (!this.isEmpty(period)) {
        value = period.text;
      }
    }

    return value;
  },
  getDefaultPeriods() {
    return collect([
      {value: 20151, text: '2015/2016 Gasal'},
      {value: 20152, text: '2015/2016 Genap'},
      {value: 20161, text: '2016/2017 Gasal'},
      {value: 20162, text: '2016/2017 Genap'},
      {value: 20171, text: '2017/2018 Gasal'},
      {value: 20172, text: '2017/2018 Genap'},
      {value: 20181, text: '2018/2019 Gasal'},
      {value: 20182, text: '2018/2019 Genap'},
      {value: 20191, text: '2019/2020 Gasal'},
      {value: 20192, text: '2019/2020 Genap'},
      {value: 20201, text: '2020/2021 Gasal'},
      {value: 20202, text: '2020/2021 Genap'},
      {value: 20211, text: '2021/2022 Ganjil'},
      {value: 20212, text: '2021/2022 Genap'},
      {value: 20221, text: '2022/2023 Ganjil'},
      {value: 20222, text: '2022/2023 Genap'},
    ]).sortByDesc('value').toArray()
  },
  getUid() {
    if (process.browser) {
      return crypto.MD5(`${process.env.APP_ID}${process.env.APP_SECRET_KEY}`).toString();
    }

    return crypto.MD5(`${process.env.APP_ID}${process.env.APP_SECRET_KEY}`).toString();
  },
  encodeToken(token) {
    let uid = this.getUid();
    return `${token.substring(0, process.env.APP_UID_POSITION)}${uid}${token.substring(parseInt(process.env.APP_UID_POSITION) - 1)}`;
  },
  parseJwt(token) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(Buffer.from(base64, 'base64').toString().split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  },
  isEmpty(data) {
    let isArray = Array.isArray(data);

    if (data !== null && data !== undefined) {
      if (isArray || typeof data == 'string') {
        if (data.length > 0) {
          return false;
        } else {
          return true;
        }
      }

      return false;
    }

    return true;
  },
  _moment(date = null, local = true) {
    if (typeof date === "number") {
      if (local) {
        return this.momentCreateFromUnixTimestamp(date).local();
      }

      return this.momentCreateFromUnixTimestamp(date);
    }

    if (local) {
      return moment(date).local();
    }

    return moment(date);
  },
  _base_moment() {
    return moment
  },
  date_humanize(date, local = true) {
    if (!this.isEmpty(date)) {
      if (local) {
        return moment(date).local().fromNow();
      }

      return moment(date).fromNow();
    }

    return '-';
  },
  momentCreateFromUnixTimestamp(timestamp) {
    return moment.unix(timestamp);
  },
  getFormattedDate(date, with_time = true, local = true) {
    if (this.isEmpty(date)) {
      return '-';
    }

    if (local) {
      date = moment(date).local();
    } else {
      date = moment(date);
    }

    let date_format = "MMMM YYYY, HH:mm";
    if (!with_time) {
      date_format = "MMMM YYYY"
    }

    return `${this.capitalize(date.format('dddd'))}, ${this.capitalize(date.format('Do'))} ${this.capitalize(date.format(date_format))}`;
  },
  dateFormat(date, format = 'YYYY-MM-DD HH:mm:ss', local = true) {
    if (this.isEmpty(date)) {
      return '-';
    }

    if (local) {
      return moment(date).local().format(format);
    } else {
      return moment(date).format(format);
    }
  },
  getDate(date, local = true) {
    if (local) {
      date = moment(date).local();
    } else {
      date = moment(date);
    }

    return date.format("Do MMMM YYYY");
  },
  getTimeOfDate(date, local = true) {
    if (local) {
      date = moment(date).local();
    } else {
      date = moment(date);
    }

    return date.format("HH:mm");
  },
  isDateBetween(started_at, ended_at) {
    return moment().isBetween(started_at, ended_at);
  },
  isNow(date_string) {
    return moment().isSame(date_string, 'd');
  },
  isPast(date_string) {
    return moment().isAfter(date_string);
  },
  isBefore(date_string) {
    return moment().isBefore(date_string);
  },
  isDateSameOrAfter(date_string, precision) {
    if (precision !== undefined) {
      return moment().isSameOrAfter(date_string, precision)
    }

    return moment().isSameOrAfter(date_string)
  },
  keyAlphabet(key) {
    let alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return alphabets[key]
  },
  str_random() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
  },
  transformKeysTo(data, case_type = 'snake_case') {
    const $this = this;
    let new_data = null;
    if (_.isArray(data)) {
      new_data = []
    } else if (_.isObject(data)) {
      new_data = {}
    }

    _.each(data, function (item, key) {
      if (_.isArray(item)) {
        item = collect(item).map((i) => {
          return $this.transformKeysTo(i, case_type);
        }).toArray();
      } else if (_.isObject(item)) {
        item = $this.transformKeysTo(item, case_type);
      }

      key = case_type == 'snake_case' ? _.snakeCase(key) : _.camelCase(key);
      new_data[key] = item;
    });

    return new_data;
  },
  urlify(text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function (url) {
      return '<a href="' + url + '">' + url + '</a>';
    })
  },
  getPostTypes(type) {
    const types = {
      I: 'Info',
      S: 'Survei',
      E: 'Acara',
      Z: 'Quiz',
      Q: 'Tugas',
      M: 'Materi',
      V: 'Conference',
    };

    return types[type];
  },
  getGroupType(type) {
    const types = {
      PRIVATE: 'E',
      ACADEMIC: 'A',
      PUBLIC: 'C',
      UNIVERSITY: 'U',
    };

    return types[type];
  },
  stripHtml(html) {
    // Create a new div element
    var temporalDivElement = document.createElement("div");
    // Set the HTML content with the providen
    temporalDivElement.innerHTML = html;
    // Retrieve the text property of the element (cross-browser support)
    return temporalDivElement.textContent || temporalDivElement.innerText || "";
  },
  isImage(media) {
    return !this.isEmpty(media.mime) && media.mime.split('/')[0] == 'image';
  },
  getHostnameUrl(url) {
    var getLocation = function (href) {
      var l = document.createElement("a");
      l.href = href;

      return l;
    };

    var l = getLocation(url);

    return l.hostname
  },
  formatBytes(bytes, decimals = 2, $objectable = false) {
    let value = 0;
    let unit = "Bytes";

    if (bytes > 0) {
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
      unit = sizes[i];
    }

    if ($objectable === true) {
      return {value, unit};
    }

    return `${value} ${unit}`;
  },
  parseUnit(value, unit) {
    const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const k = 1024;
    let bytes = 1;
    units.some((u) => {
      if (u === unit) {
        return true;
      }

      bytes = bytes * k;

      return false;
    });

    return value * bytes;
  },
  getUrlParam(url_string, param) {
    var url = new URL(url_string);
    var c = url.searchParams.get(param);

    return c;
  },
  secondsToFormat(s, format = 'mm:ss') {
    return moment().startOf('day')
      .seconds(s)
      .format(format);
  },
  readableValue(val) {
    if (!this.isEmpty(val)) {
      if (isNaN(val) || (!isNaN(val) && val <= 0)) {
        return '-'
      }

      return val;
    }

    return '-'
  },
  str_slug(str) {
    if (this.isEmpty(str)) {
      return str;
    }

    return str
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/[^\w-]+/g, '');
  },
  get_youtube_info_from_url(url) {
    var videoid = url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
    if (videoid != null) {
      return videoid[1];
    }

    return null;
  },
  getActDesc(post) {
    let act_desc = '';
    if (['G', 'P', '0', 'D'].indexOf(post.type) > -1) act_desc = 'menambahkan berita ';
    else if (post.type == 'Z') act_desc = 'menambahkan quiz pada ';
    else if (post.type == 'M') act_desc = 'menambahkan materi pada ';
    else if (post.type == 'I') act_desc = 'memposting informasi';
    else if (post.type == 'E') act_desc = 'menambahkan acara';
    else if (post.type == 'S') act_desc = 'menambahkan survei ';
    else if (post.type == 'Q') act_desc = 'menambahkan tugas ';
    else if (post.type == 'V') act_desc = 'menambahkan conference pada ';
    else if (post.type == '1') act_desc = 'membagikan tugas kelompok ';

    return act_desc;
  },
  ga_send_event(auth, customdata = null) {
    if (process.env.APP_ENV !== 'production') {
      return;
    }
    const account = !this.isEmpty(auth) && !this.isEmpty(auth.active_pt) ? auth.active_pt : null;

    if (!this.isEmpty(auth)) {
      let eventdata = {
        'dimension2': auth.name,
        'dimension3': auth.email,
        'dimension5': 'general',
      }

      if (!this.isEmpty(account)) {
        eventdata['dimension1'] = account.universityId.toString()
        eventdata['dimension5'] = account.type
        eventdata['dimension6'] = account.name
        eventdata['dimension7'] = account.university.name

        if (!this.isEmpty(account.userUniversityId)) {
          eventdata['dimension4'] = account.userUniversityId
        }
      }

      eventdata = Object.assign({
        hitType: 'event',
        eventCategory: 'general',
        eventAction: 'push_custom_var',
      }, eventdata, {});

      if (!this.isEmpty(customdata)) {
        eventdata = Object.assign(eventdata, customdata, {});
      }

      ga('send', eventdata)
    }
  },
  getPostDetailUrl(post) {
    const vm = this;
    let group_type = post.group.type == 'A' ? 'classes' : 'groups';

    if (['G', 'P', '0', 'D'].indexOf(post.group.type) > -1) {
      return post.extUrl
    } else if (post.group.type == 'U') {
      return `/panel/university/news/${post.id}`
    } else if (!vm.isEmpty(post.section) && ['M', 'Z', 'Q', 'V'].indexOf(post.type) > -1) {
      return `/panel/${group_type}/${post.groupId}/sections/${post.section.id}/${post.id}`
    } else {
      return `/panel/${group_type}/${post.groupId}/${post.id}`
    }
  },
  shareableDescription(post) {
    if (['G', 'P', '0', 'D'].indexOf(post.type) > -1) {
      return !this.isEmpty(post.excerpt) ? post.excerpt : post.cleanDescription;
    }

    return !this.isEmpty(post.excerpt) ? post.excerpt : post.title;
  },
  getPostAuthor(post) {
    if (post.type == 'P') {
      return 'Campuspedia';
    } else if (post.type == 'G') {
      return 'GNFI'
    } else if (post.type == 'D') {
      return 'Dunia Dosen'
    } else if (post.type == 0) {
      return 'Sevima'
    } else if (!this.isEmpty(post.user)) {
      return post.user.name
    }

    return ''
  },
  getPostAvatar(post) {
    let avatar = '';
    if (post.type == 'G') {
      avatar = '/assets/img/gnfi-small.jpg'
    } else if (post.type == 'P') {
      avatar = '/assets/img/campuspedia-small.jpg'
    } else if (post.type == 'D') {
      avatar = '/assets/img/duniadosen-small.jpg'
    } else if (post.type == 0) {
      avatar = '/assets/img/sevima-small.png'
    } else if (!this.isEmpty(post.user) && !this.isEmpty(post.user.media) && !this.isEmpty(post.user.media.images)) {
      avatar = post.user.media.images.thumb.link
    }

    return avatar
  },
  convertToCriterionDataProvider(criterions, item) {
    criterions = collect(criterions);
    let criterion = collect(criterions).where('criteria', '==', item.criteria).first();

    if (!this.isEmpty(criterion)) {
      criterions = criterions.map((i) => {
        if (i.criteria == item.criteria) {
          return item
        }

        return i
      })
    } else {
      criterions = criterions.merge([item]);
    }

    return criterions.toArray()
  },
  openDocument(url) {
    window.open(
      `https://docs.google.com/gview?url=${url}`,
      '_blank'
    );
  },
  getRangeYears(startYear) {
    var currentYear = new Date().getFullYear(), years = [];
    startYear = startYear || 1900;
    while (startYear <= currentYear) {
      years.push(startYear++);
    }

    return collect(years).sort((a, b) => b - a).toArray();
  },
  getDates(startDate, endDate) {
    startDate = moment(startDate);
    endDate = moment(endDate);

    const dates = [];
    let currentDate = startDate;
    while (currentDate <= endDate) {
      dates.push(currentDate.clone().format('DD MMM YYYY'));
      currentDate = currentDate.clone().add(1, "day");
    }

    return dates;
  },
  getActivityDesc(key) {
    let act_desc = '';
    if (key == 'view_post') act_desc = 'melihat postingan ';
    else if (key == 'view_detail_learning_material') act_desc = 'melihat materi ';
    else if (key == 'share_post') act_desc = 'membagikan postingan ';
    else if (key == 'add_new_media') act_desc = 'menambahkan media baru ';
    else if (key == 'upload_media') act_desc = 'mengunggah berkas baru';
    else if (key == 'download_media') act_desc = 'mengunduh berkas ';
    else if (key == 'add_new_post') act_desc = 'membagikan postingan baru ';
    else if (key == 'view_profile') act_desc = 'melihat profil ';
    else if (key == 'like_post') act_desc = 'menyukai postingan ';
    else if (key == 'assignment_submitted') act_desc = 'menyerahkan tugas ';
    else if (key == 'quiz_started') act_desc = 'mulai mengerjakan quiz ';
    else if (key == 'quiz_ended') act_desc = 'telah menyelesaikan quiz ';
    else if (key == 'assignment_shared') act_desc = 'membagikan tugas baru ';
    else if (key == 'quiz_shared') act_desc = 'membagikan quiz baru';
    else if (key == 'survey_shared') act_desc = 'membagikan survey ';
    else if (key == 'event_shared') act_desc = 'membagikan acara ';
    else if (key == 'learning_material_shared') act_desc = 'membagikan materi baru ';
    else if (key == 'conference_shared') act_desc = 'membagikan ruang conference ';
    else if (key == 'add_new_comment') act_desc = 'memberikan komentar ';

    return act_desc;
  },
  getCriterion(dataProvider, key = null) {
    if (this.isEmpty(key)) {
      return null;
    }

    let criterion = collect(dataProvider.criterion).where('criteria', '==', key).first();

    if (!this.isEmpty(criterion)) {
      return criterion.value
    }

    return null
  },
  isPass(user = null, permission_names = []) {
    user = !this.isEmpty(user) ? user : this.auth;
    if (this.isEmpty(user)) {
      return false;
    }

    let user_permissions = user.permissionNames

    return collect(permission_names).diff(user_permissions).count() == 0
  },
  isEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  },
  getDuration(startedAt, endedAt) {
    if (this.isEmpty(startedAt)) {
      return '-'
    }

    var end = moment(endedAt).valueOf();
    var start = moment(startedAt).valueOf();
    // Find the distance between now and the count down date
    var distance = end - start;
    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    let duration_string = '';

    if (days > 0) {
      duration_string = duration_string + ` ${days} Hari`
    }

    if (hours > 0) {
      duration_string = duration_string + ` ${hours} Jam`
    }

    if (minutes > 0) {
      duration_string = duration_string + ` ${minutes} Menit`
    }

    if (seconds > 0) {
      duration_string = duration_string + ` ${seconds} Detik`
    }

    return duration_string
  },
  showPreview(media) {
    if (['document', 'link'].indexOf(media.type) > -1) {
      if (media.type == 'link' && !this.isEmpty(media.link)) {
        window.open(media.link, '_blank');
      } else if (media.type == 'document' && !this.isEmpty(media.file) && !this.isEmpty(media.file.link)) {
        this.openDocument(media.file.link);
      }
    }
  },
  convertStringToSpaceless(string) {
    let s = string.replace(/\s/g, '')
    s = s.replace(/\s/g, '')

    return s;
  },
  secondsToHms(d, readable = true) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " Jam " : " Jam ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " Menit " : " Menit ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? " Detik" : " Detik") : "";

    if (readable) {
      return hDisplay + mDisplay + sDisplay;
    }

    return {
      hours: h,
      minutes: m,
      seconds: s
    }
  },
  numberFormat(string) {
    return string.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  },
  isNetworkRelatedError(err) {
    return err.code === "ECONNABORTED" || err.message === "Network Error";
  },
  validateInputLength(event, maxLength) {
    if (event.target.value.length >= maxLength) {
      event.preventDefault()
    }
  },
  validateGradeValue(event) {
    if (event.target.value != null) {
      if (event.target.value == "") {
        event.target.value = "0"
      }
      if (Number(event.target.value) >= 100) {
        event.target.value = "100"
        event.preventDefault()
      }
      if (event.target.value.length > 1) {
        var parse = event.target.value.split('')
        if (parse[0] == '0') {
          event.target.value = `${parse[1]}`
        }
      }
    }
  },
  getPostTypeMap(postType) {
    let type;
    switch (postType) {
      case '1':
        type = 'task_team';
        break;
      case 'I':
        type = 'info';
        break;
      case 'S':
        type = 'survey';
        break;
      default:
        break;
    }

    return type;
  },

  dateformatterIndo(data) {
    var date = new Date(data);

    var tahun = date.getFullYear();
    var bulan = date.getMonth();
    var tanggal = date.getDate();
    var hari = date.getDay();

    switch (hari) {
      case 0:
        hari = "Minggu";
        break;
      case 1:
        hari = "Senin";
        break;
      case 2:
        hari = "Selasa";
        break;
      case 3:
        hari = "Rabu";
        break;
      case 4:
        hari = "Kamis";
        break;
      case 5:
        hari = "Jum'at";
        break;
      case 6:
        hari = "Sabtu";
        break;
    }

    switch (bulan) {
      case 0:
        bulan = "Januari";
        break;
      case 1:
        bulan = "Februari";
        break;
      case 2:
        bulan = "Maret";
        break;
      case 3:
        bulan = "April";
        break;
      case 4:
        bulan = "Mei";
        break;
      case 5:
        bulan = "Juni";
        break;
      case 6:
        bulan = "Juli";
        break;
      case 7:
        bulan = "Agustus";
        break;
      case 8:
        bulan = "September";
        break;
      case 9:
        bulan = "Oktober";
        break;
      case 10:
        bulan = "November";
        break;
      case 11:
        bulan = "Desember";
        break;
    }

    return hari + ", " + tanggal + " " + bulan + " " + tahun;
  },

  randomString(length, uppercase = false) {
    let string = Math.round((Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))).toString(36).slice(1);
    if (uppercase) {
      return string.toUpperCase();
    }

    return string;
  },
  downloadFromIntegration(media, mediaResponse = false) {
    if (mediaResponse) {
      window.open(media.values.downloadLink);
    } else {
      window.open(media.downloadLink);
    }
  },
  getToken() {
    let token = this.$route.query.t;
    token = this.isEmpty(token) ? this.$cookies.get('token') : token;

    if (token) {
      let no_need_encode = false;
      try {
        no_need_encode = this.parseJwt(token)
        no_need_encode = !this.isEmpty(no_need_encode) && !this.isEmpty(no_need_encode.username) && !this.isEmpty(no_need_encode.appid)
      } catch (e) {
      }

      token = no_need_encode ? token : this.encodeToken(token)

      return token;
    }

    return null
  },

  dateSectionFormat(started, ended) {
    const date = this.dateFormat(started, 'DD MMMM YYYY');
    const startedTime = this.dateFormat(started, 'HH:mm');
    const endedTime = this.dateFormat(ended, 'HH:mm');
    return `${date} ${startedTime} - ${endedTime}`;
  },

  learningMaterialToString(type = null) {
    switch (type) {
      case 'M':
        return 'Materi'
      case 'Q':
        return 'Tugas'
      case 'V':
        return 'Video Conference'
      case 'Z':
        return 'Quiz'
      default:
        return null;
    }
  },
  storeLocalStorage(key, value) {
    if (this.isEmpty(key)) {
      return;
    }

    localStorage.setItem(key, value)
  },
  removeLocalStorage(key) {
    localStorage.removeItem(key)
  },
  async getLocalStorage(key) {
    if (this.isEmpty(key)) {
      return;
    }

    const getItem = localStorage.getItem(key)
    return JSON.parse(getItem)
  }
};

Vue.mixin({
  data() {
    return {
      time_to_track_post: 3,
      moment,
      loading_download_media: false
    }
  },

  computed: {
    ...mapState({
      auth: state => state.auth,
      isTeacher: state => state.isTeacher,
      isStudent: state => state.isStudent,
      isAdmin: state => state.isAdmin,
      isLead: state => state.isLead,
      hasLead: state => state.hasLead,
      editMode: state => state.editMode,
      maintenance_message: state => state.maintenance_message,
      show_dashboard_admin: state => state.show_dashboard_admin,
      show_leader_dashboard: state => state.show_leader_dashboard,
    }),
    edit_mode() {
      return this.isTeacher && this.editMode
    },
    isQuizBuilderEditable() {
      return this.$route.query.edit === "true" || this.isEmpty(this.$route.query.edit)
    }
  },

  methods: helpers
})

export default helpers;
